import React from "react";
import "../design/resetPassword.css"

export default function SuccessPage() {

    return(
        <div>
            <h1 className="header"> Reset Your Password </h1>

            <div className="resetPasswordBackground">
            
            <h2 className="resetPasswordSuccessMessage"> 
                Your password has been successfully reset! You can now log in to your account from the app.
                </h2>

        </div>
        </div>
    )
}